import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GeoService } from '../../services/geo.service';
import { AuthService } from '../../services/auth.service';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-create-account',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit {
  private geoService = inject(GeoService);
  private router = inject(Router);
  private authService = inject(AuthService);
  private apiService = inject(ApiService);

  businessName = '';
  email = '';
  phone = '';
  loginUrl = '';
  password = '';

  passwordVisible = false;
  isCountryDropdownOpen = false;
  isLoading = false;
  errorMessage = '';

  countryCodes = [
    { code: '+1', country: 'US/CA', iso: 'US', placeholder: '202 555 0123' },
    { code: '+44', country: 'UK', iso: 'GB', placeholder: '7700 900077' },
    { code: '+20', country: 'Egypt', iso: 'EG', placeholder: '101 234 5678' },
    { code: '+966', country: 'Saudi Arabia', iso: 'SA', placeholder: '50 123 4567' },
    { code: '+971', country: 'UAE', iso: 'AE', placeholder: '50 123 4567' },
    { code: '+965', country: 'Kuwait', iso: 'KW', placeholder: '5123 4567' },
    { code: '+974', country: 'Qatar', iso: 'QA', placeholder: '3312 3456' },
    { code: '+973', country: 'Bahrain', iso: 'BH', placeholder: '3312 3456' },
    { code: '+968', country: 'Oman', iso: 'OM', placeholder: '9123 4567' },
    { code: '+962', country: 'Jordan', iso: 'JO', placeholder: '7 9123 4567' },
    { code: '+961', country: 'Lebanon', iso: 'LB', placeholder: '3 123 456' },
    { code: '+964', country: 'Iraq', iso: 'IQ', placeholder: '790 123 4567' },
    { code: '+963', country: 'Syria', iso: 'SY', placeholder: '93 123 4567' },
    { code: '+970', country: 'Palestine', iso: 'PS', placeholder: '59 123 4567' },
    { code: '+967', country: 'Yemen', iso: 'YE', placeholder: '71 123 4567' },
    { code: '+212', country: 'Morocco', iso: 'MA', placeholder: '612 345 678' },
    { code: '+213', Algeria: 'DZ', placeholder: '551 23 45 67' },
    { code: '+216', country: 'Tunisia', iso: 'TN', placeholder: '98 123 456' },
    { code: '+218', country: 'Libya', iso: 'LY', placeholder: '91 123 4567' },
    { code: '+249', country: 'Sudan', iso: 'SD', placeholder: '91 234 5678' },
    { code: '+222', country: 'Mauritania', iso: 'MR', placeholder: '41 23 45 67' },
    { code: '+252', country: 'Somalia', iso: 'SO', placeholder: '61 234 5678' },
    { code: '+253', country: 'Djibouti', iso: 'DJ', placeholder: '77 12 34 56' },
    { code: '+269', country: 'Comoros', iso: 'KM', placeholder: '321 2345' }
  ];

  selectedCountry = this.countryCodes[2]; // Default +20 (Egypt)

  ngOnInit() {
    this.detectCountry();
  }

  detectCountry() {
    this.geoService.getUserCountry().subscribe(isoCode => {
      if (isoCode) {
        const detected = this.countryCodes.find(c => c.iso === isoCode);
        if (detected) {
          this.selectedCountry = detected;
        }
      }
    });
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  toggleCountryDropdown() {
    this.isCountryDropdownOpen = !this.isCountryDropdownOpen;
  }

  selectCountry(country: any) {
    this.selectedCountry = country;
    this.isCountryDropdownOpen = false;
  }

  async onSubmit(event: Event) {
    event.preventDefault();
    if (!this.businessName || !this.email || !this.phone || !this.loginUrl || !this.password) return;

    this.isLoading = true;
    this.errorMessage = '';

    try {
      // 1. Create the Firebase account and send verification email (or mock resolution)
      await this.authService.registerUser(this.email, this.password);
      
      // 2. Submit the registration lead to our local CRM mock backend
      const registrationData = {
        businessName: this.businessName,
        email: this.email,
        phone: this.selectedCountry.code + ' ' + this.phone,
        loginUrl: this.loginUrl
      };

      this.apiService.submitRegistration(registrationData).subscribe({
        next: (res) => {
          console.log('Registration Lead successfully posted to CRM:', res);
        },
        error: (err) => {
          console.error('Failed to post registration lead to CRM:', err);
        }
      });

      // 3. Navigate to the "Check your inbox" page
      this.router.navigate(['/email-verification'], { 
        state: { email: this.email } 
      });
    } catch (error: any) {
      this.errorMessage = error.message || 'Failed to create account. Please try again.';
      console.error('Registration error:', error);
    } finally {
      this.isLoading = false;
    }
  }
}
